import React from 'react';
import Button from 'components/ui/Button';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  const handleProfessionalSignup = () => {
    navigate('/signup-form?role=professional');
  };

  const handleClientSignup = () => {
    navigate('/registrati-cliente');
  };

  return (
    <section className="w-full bg-gradient-to-br from-primary via-primary/95 to-primary/90 py-12 md:py-16 lg:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col gap-6 md:gap-8 lg:gap-10 text-center">
          <div className="flex flex-col gap-3 md:gap-4">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
              Inizia Oggi a Lavorare Localmente
            </h2>
            <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto">Più vicino. Più veloce. Più conveniente.<br />
Unisciti alla community di professionisti e clienti del futuro, dove le opportunità nascono vicino a te.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 md:gap-5 lg:gap-6 justify-center items-center">
            <Button
              variant="secondary"
              size="lg"
              onClick={handleProfessionalSignup}
              iconName="Briefcase"
              iconPosition="left"
              className="w-full sm:w-auto bg-white text-primary hover:bg-white/90">

              Registrati come Professionista
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={handleClientSignup}
              iconName="Users"
              iconPosition="left"
              className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-primary">

              Trova un Professionista
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 md:gap-6 lg:gap-8 justify-center items-center text-white/80 text-sm md:text-base">
            <div className="flex items-center gap-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>Registrazione gratuita</span>
            </div>
            <div className="flex items-center gap-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>Nessun costo nascosto</span>
            </div>
            <div className="flex items-center gap-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>Supporto dedicato</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default CTASection;